import type { WorkerSchema } from "@aera/data-table";

/** FilterBar schema for งานเงิน queue — mirrors รายรับ date/sort chrome. */
export const WORK_QUEUE_FILTER_SCHEMA: WorkerSchema = {
  workerId: "financial-work-queue",
  workerLabel: "งานเงิน",
  tabIcon: "wallet",
  recordPrefix: "FW",
  apiEndpoint: "/api/v1/financial-work/feed/all",
  defaultSort: { col: "record_date", dir: "desc" },
  searchFields: ["title", "subtitle"],
  columns: [
    {
      id: "record_date",
      header: "วันที่",
      type: "datetime",
      editable: false,
      sortable: true,
      visibility: "always",
      width: 150,
    },
    {
      id: "money_in",
      header: "เงินเข้า",
      type: "amount",
      editable: false,
      sortable: true,
      visibility: "always",
      align: "right",
    },
    {
      id: "money_out",
      header: "เงินออกจริง",
      type: "amount",
      editable: false,
      sortable: true,
      visibility: "always",
      align: "right",
    },
    {
      id: "related",
      header: "ยอดที่เกี่ยวข้อง",
      type: "amount",
      editable: false,
      sortable: true,
      visibility: "always",
      align: "right",
    },
  ],
  filterOptions: {
    status: [
      "⚠️ รอการตัดสินใจ",
      "⚠️ รอจับคู่",
      "⚠️ จ่ายบางส่วน รอสลิป",
      "⚠️ ต้องตรวจ",
      "🔴 ต้องระวัง",
      "✅ ปิดยอดแล้ว",
      "🔴 ยังไม่จ่าย",
    ],
    datePresets: [
      "วันนี้",
      "7 วันที่ผ่านมา",
      "เดือนนี้",
      "เดือนที่แล้ว",
      "กำหนดเอง",
    ],
    /** Same buckets as แท็บข้อมูล — filter queue rows by money kind. */
    categoryLabel: "ประเภท",
    categories: ["รายรับ", "รายจ่าย", "ยอดค้าง"],
  },
  drawerSections: [],
  emptyState: {
    icon: "💰",
    title: "ไม่มีรายการ",
    body: "เมื่อมีงานเงินที่เกี่ยวข้อง จะแสดงที่นี่",
  },
};
